import { render } from "./LayoutDashboard.vue?vue&type=template&id=6a17ff80"
import script from "./LayoutDashboard.vue?vue&type=script&lang=js"
export * from "./LayoutDashboard.vue?vue&type=script&lang=js"

import "./LayoutDashboard.vue?vue&type=style&index=0&id=6a17ff80&lang=less"

import exportComponent from "/home/rampa/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__